<script setup>
import FormModal from "@Components/Modal/FormModal.vue";
import { FormTextarea } from "@Components/Form";
import ActionMessage from "@Components/ActionMessage.vue";
import { PrimaryButton } from "@Components/Button";
import { useStore } from "@/Stores/templates";
import { useForm } from "@/form";
import { useI18n } from "vue-i18n";
import { ref } from "vue";

const importForm = useForm({
    import_data: undefined,
});

const store = useStore();
const { t: __ } = useI18n();

const modal = ref();

const importTemplate = async () => {
    if (importForm.processing) {
        return;
    }

    await importForm.post("templates_import");

    store.fetch();

    hide();

    importForm.reset();
};

const show = () => {
    modal.value.show();
};

const hide = () => {
    modal.value.hide();
};
defineExpose({ show, hide });
</script>

<template>
    <FormModal ref="modal" @submit="importTemplate" :title="__('Importer un template')">
        <template #body>
            <div class="space-y-6">
                <FormTextarea
                    :z="1"
                    :label="__('Code d\'importation')"
                    v-model="importForm.import_data"
                    rows="5"
                    :errors="importForm.getErrors('import_data')" />
            </div>
        </template>
        <template #actions>
            <div class="flex justify-end items-center">
                <ActionMessage :on="importForm.recentlySuccessful" class="mr-3"> {{ __("Importé.") }} </ActionMessage>
                <PrimaryButton :z="1" :processing="importForm.processing" type="submit">
                    {{ __("Importer") }}
                </PrimaryButton>
            </div>
        </template>
    </FormModal>
</template>
